export class SearchFakeDb
{
    public static classic = [
        {
            'title'  : 'Dynamically Procrastinate B2C',
            'url'    : 'ourwebaddress.com/articles/procrastinate',
            'excerpt': 'Collaboratively administrate empowered markets via plug-and-play networks. Dynamically procrastinate B2C users after installed base benefits.'
        },
        {
            'title'  : 'Cross Media',
            'url'    : 'ourwebaddress.com/articles/cross-media',
            'excerpt': 'Efficiently unleash cross-media information without cross-media value. Quickly maximize timely deliverables for real-time schemas.'
        },
        {
            'title'  : 'Synergize',
            'url'    : 'ourwebaddress.com/articles/synergize',
            'excerpt': 'Completely synergize resource taxing relationships via premier niche markets. Professionally cultivate one-to-one customer service with robust ideas.'
        },
        {
            'title'  : 'Parallel Platforms',
            'url'    : 'ourwebaddress.com/articles/parallel-paltforms',
            'excerpt': 'Objectively innovate empowered manufactured products whereas parallel platforms. Holisticly predominate extensible testing procedures for reliable supply chains.'
        },
        {
            'title'  : 'Growth Strategies',
            'url'    : 'ourwebaddress.com/articles/growth-strategies',
            'excerpt': 'Proactively envisioned multimedia based expertise and cross-media growth strategies. Holistically pontificate installed base portals after maintainable products.'
        },
        {
            'title'  : 'Methodologies',
            'url'    : 'ourwebaddress.com/articles/methodologies',
            'excerpt': 'Phosfluorescently engage worldwide methodologies with web-enabled technology. Completely pursue scalable customer service through sustainable potentialities.'
        },
        {
            'title'  : 'E-tailers',
            'url'    : 'ourwebaddress.com/articles/e-trailers',
            'excerpt': 'Collaboratively administrate turnkey channels whereas virtual e-tailers. Objectively seize scalable metrics whereas proactive e-services.'
        },
        {
            'title'  : 'Web Readiness',
            'url'    : 'ourwebaddress.com/articles/web-readiness',
            'excerpt': 'Credibly innovate granular internal or organic sources whereas high standards in web-readiness. Dramatically synthesize integrated schemas with optimal networks.'
        }
    ];

    public static table = [
        {
            'name'     : 'Airi Satou',
            'position' : 'Accountant',
            'office'   : 'Tokyo',
            'age'      : '33',
            'startDate': '2008/11/28',
            'salary'   : '162700',
            'email'    : 'a.satou@mail.com'
        },
        {
            'name'     : 'Angellica Ramos',
            'position' : 'Chief Executive Officer (CEO)',
            'office'   : 'London',
            'age'      : '47',
            'startDate': '2009/10/09',
            'salary'   : '1200000',
            'email'    : 'a.ramos@mail.com'
        },
        {
            'name'     : 'Ashton Cox',
            'position' : 'Hunior Technical Author',
            'office'   : 'San Fransisco',
            'age'      : '66',
            'startDate': '2009/01/12',
            'salary'   : '86000',
            'email'    : 'a.cox@mail.com'
        },
        {
            'name'     : 'Bradley Greer',
            'position' : 'Software Engineer',
            'office'   : 'London',
            'age'      : '41',
            'startDate': '2012/10/13',
            'salary'   : '132000',
            'email'    : 'b.greer@mail.com'
        },
        {
            'name'     : 'Brenden Wagner',
            'position' : 'Software Engineer',
            'office'   : 'San Fransisco',
            'age'      : '28',
            'startDate': '2011/06/07',
            'salary'   : '206850',
            'email'    : 'b.wagner@mail.com'
        },
        {
            'name'     : 'Brielle Williamson',
            'position' : 'Integration Specialist',
            'office'   : 'New York',
            'age'      : '61',
            'startDate': '2012/12/02',
            'salary'   : '372000',
            'email'    : 'b.williamson@mail.com'
        },
        {
            'name'     : 'Bruno Nash',
            'position' : 'Software Engineer',
            'office'   : 'London',
            'age'      : '38',
            'startDate': '2011/05/03',
            'salary'   : '163500',
            'email'    : 'b.nash@mail.com'
        },
        {
            'name'     : 'Caesar Vance',
            'position' : 'Pre-Sales Support',
            'office'   : 'New York',
            'age'      : '21',
            'startDate': '2011/12/12',
            'salary'   : '106450',
            'email'    : 'c.vance@mail.com'
        },
        {
            'name'     : 'Cara Stevens',
            'position' : 'Sales Assistant',
            'office'   : 'New York',
            'age'      : '46',
            'startDate': '2011/12/06',
            'salary'   : '145600',
            'email'    : 'c.stevens@mail.com'
        },
        {
            'name'     : 'Cedric Kelly',
            'position' : 'Senior Javascript Developer',
            'office'   : 'Edinburg',
            'age'      : '22',
            'startDate': '2012/03/29',
            'salary'   : '433060',
            'email'    : 'c.kelly@mail.com'
        }
    ];

}
